import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-gray-900 text-gray-400 pt-8 pb-24 md:pb-8 px-6 border-t-4 border-gold" data-id="element-72">
        <div className="max-w-4xl mx-auto flex flex-col items-center text-center gap-4" data-id="element-73">
          <div data-id="element-74">
            <h3 className="text-xl font-serif text-cream mb-1" data-id="element-75">
              El Salto de Novia a Esposa
            </h3>
            <p className="text-gold italic font-serif text-base" data-id="element-76">
              Para la mujer que eligió su propio valor.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6" data-id="element-77">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-gray-400 hover:text-gold transition-colors underline underline-offset-2" data-id="element-78">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-gray-400 hover:text-gold transition-colors underline underline-offset-2" data-id="element-79">
              Términos y Condiciones
            </button>
            <a href="#" className="text-sm text-gray-400 hover:text-gold transition-colors underline underline-offset-2" data-id="element-80">
              Contacto
            </a>
          </div>

          <p className="text-sm text-gray-500" data-id="element-81">
            © {new Date().getFullYear()} El Salto de Novia a Esposa. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-82">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-83">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto relative" onClick={e => e.stopPropagation()} data-id="element-84">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between z-10" data-id="element-85">
                <h2 className="text-lg font-bold text-burgundy font-serif" data-id="element-86">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-1 rounded-full hover:bg-gray-100 transition-colors text-gray-500 hover:text-burgundy" aria-label="Cerrar" data-id="element-87">
                  <XIcon className="w-5 h-5" data-id="element-88" />
                </button>
              </div>

              <div className="px-6 py-6 text-gray-700 text-sm leading-relaxed space-y-4" data-id="element-89">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-90" /> : <TermsContent data-id="element-91" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="font-bold text-burgundy text-base" data-id="element-92">
        Política de Privacidad
      </p>
      <p data-id="element-93">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <p className="font-semibold mt-4" data-id="element-94">1. Información que Recopilamos</p>
      <p data-id="element-95">
        Recopilamos información personal que usted nos proporciona
        voluntariamente al realizar una compra, como su nombre y dirección de
        correo electrónico. También podemos recopilar información de pago a
        través de nuestros procesadores de pago de terceros.
      </p>

      <p className="font-semibold mt-4" data-id="element-96">2. Uso de la Información</p>
      <p data-id="element-97">
        Utilizamos la información recopilada para procesar sus pedidos, enviarle
        el producto digital adquirido, y comunicarnos con usted sobre su compra.
        No compartimos su información personal con terceros con fines de
        marketing.
      </p>

      <p className="font-semibold mt-4" data-id="element-98">3. Protección de Datos</p>
      <p data-id="element-99">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger su información personal contra el acceso no autorizado, la
        alteración, divulgación o destrucción.
      </p>

      <p className="font-semibold mt-4" data-id="element-100">4. Cookies</p>
      <p data-id="element-101">
        Nuestro sitio web puede utilizar cookies para mejorar su experiencia de
        navegación. Puede configurar su navegador para rechazar cookies, aunque
        esto podría afectar la funcionalidad del sitio.
      </p>

      <p className="font-semibold mt-4" data-id="element-102">5. Sus Derechos</p>
      <p data-id="element-103">
        Usted tiene derecho a acceder, rectificar o eliminar sus datos
        personales en cualquier momento. También puede solicitar la limitación
        del tratamiento de sus datos o ejercer su derecho a la portabilidad de
        los mismos.
      </p>

      <p className="font-semibold mt-4" data-id="element-104">6. Cambios en esta Política</p>
      <p data-id="element-105">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="font-bold text-burgundy text-base" data-id="element-106">
        Términos y Condiciones
      </p>
      <p data-id="element-107">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <p className="font-semibold mt-4" data-id="element-108">1. Producto Digital</p>
      <p data-id="element-109">
        "El Salto de Novia a Esposa" es un producto digital (eBook) que se
        entrega en formato electrónico tras la confirmación del pago. Al
        realizar la compra, usted acepta estos términos y condiciones.
      </p>

      <p className="font-semibold mt-4" data-id="element-110">2. Uso Personal</p>
      <p data-id="element-111">
        El contenido adquirido es para uso personal y exclusivo del comprador.
        Queda prohibida la reproducción, distribución, modificación o reventa
        total o parcial del material sin autorización expresa por escrito.
      </p>

      <p className="font-semibold mt-4" data-id="element-112">3. Propiedad Intelectual</p>
      <p data-id="element-113">
        Todo el contenido, incluyendo textos, gráficos, diseños y metodologías,
        está protegido por derechos de autor. La compra del producto no
        transfiere derechos de propiedad intelectual al comprador.
      </p>

      <p className="font-semibold mt-4" data-id="element-114">4. Política de Reembolso</p>
      <p data-id="element-115">
        Debido a la naturaleza digital del producto, no se aceptan devoluciones
        una vez que el producto ha sido entregado y descargado. Si experimenta
        problemas técnicos con la descarga, nos comprometemos a resolverlos.
      </p>

      <p className="font-semibold mt-4" data-id="element-116">5. Descargo de Responsabilidad</p>
      <p data-id="element-117">
        El contenido de este eBook es de carácter informativo y educativo. Los
        resultados pueden variar según cada persona y situación. No garantizamos
        resultados específicos en relaciones personales. Este material no
        sustituye el consejo profesional de un terapeuta o consejero de
        relaciones.
      </p>

      <p className="font-semibold mt-4" data-id="element-118">6. Modificaciones</p>
      <p data-id="element-119">
        Nos reservamos el derecho de modificar estos términos y condiciones en
        cualquier momento. Las modificaciones entrarán en vigor desde su
        publicación en esta página.
      </p>
    </>;
}